import React from 'react';
import { Link } from 'react-router-dom';
import CourseGirl from "../../assets/audio/images/coursegirls.jpg";
import NavbarAll from '../Navbar/NavbarAll';

const CourseGirls = () => {
  return (
    <>
    <NavbarAll />
    <div>
      {/* Hero Section */}
      <section className="w-100 pt-80 pb-70 black-layer position-relative">
        <div
          className="fixed-bg"
          style={{
            backgroundImage: `url(${CourseGirl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="container">
          <div className="page-title-wrap text-center w-100">
            <div className="page-title-inner d-inline-block">
              <h1 className="mb-0 text-white text-5xl font-bold">Noor After Ramadan: Boys’ Eid Milan
              </h1>
              <p className="text-white text-lg mt-2">Register for this event now</p>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details Section */}
      <section style={{ width: '100%', padding: '20px 0' }}>
        <div
          style={{
            maxWidth: '1100px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '16px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
          }}
        >
          {/* Image Card */}
          <div
            style={{
              flex: '1',
              minWidth: '300px',
              maxWidth: '400px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '100%',
                height: '500px',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <img
                src={CourseGirl}
                alt="Course for Girls"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </div>

          {/* Event Details */}
          <div
            style={{
              flex: '2',
              minWidth: '300px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <h2 style={{ fontSize: '32px', fontWeight: 'bold', color: '#2563eb', marginBottom: '20px' }}>Noor After Ramadan: Boys’ Eid Milan
            </h2>
            <p style={{ color: '#4b5563', marginBottom: '10px' }}><strong>📅 Start Date:</strong>Sunday, 20th April 2025 </p>
            <p style={{ color: '#4b5563', marginBottom: '20px' }}><strong>📍 Location:</strong> Masjid Zakaria, 109 26th Street, DHA Phase 8, Karachi</p>

            <p style={{ color: '#374151', marginBottom: '20px' }}>
            Join us for an unforgettable Eid Milan at Masjid-e-Zakaria – Games, gifts, refreshments  brotherhood, and blessings, all in the spirit of Islam!

              </p>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ fontWeight: '600', color: '#9333ea' }}>✅Age: 6-14</h3>
              <ul style={{ paddingLeft: '20px', color: '#1f2937' }}>
                <li>✅Timings: 4'o clock to Maghrib</li>
                <li>✅Registration fee: Rs. 1000/- (Fee can be paid to the Masjid anytime between Asr to Isha or on the day of the event at 3:30)</li>
                <li>✅For Defence and Clifton only
                </li>
              </ul>
            </div>

            <p style={{ color: '#f97316', marginBottom: '20px' }}>
            </p>

            {/* Register Button */}
            <div style={{ marginTop: 'auto', textAlign: 'center' }}>
              <Link
                to="https://forms.gle/kLP9ow8E2UnAzbtN6"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: 'linear-gradient(to right, #3b82f6, #6366f1)',
                  color: '#fff',
                  fontWeight: '600',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  transition: 'transform 0.3s ease',
                }}
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                Register Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default CourseGirls;
